import React from 'react';
import { useCallback, useState } from "react";
import { apiFetch } from "../../toolympus/api/core";
import { useCrudItemF } from "../../toolympus/api/useCrudItemF";
import { DocumentationDoc, DocumentationPageData } from "../../toolympus/components/Documentation/useDocumentationPages";
import { DocumentationPageUnbound } from "../../toolympus/components/Documentation/DocumentationPageUnbound";
import { ProjectDocumentationEditor } from './ProjectDocumentationEditor';
import { MediaLibProviderX } from './MediaLibProviderX';

const ApiPath = "/api/documentation";

const saveDocument = (apiPath: string, item: DocumentationDoc, changes: Partial<DocumentationDoc>) => {
    if(Object.keys(changes).length === 0) {
        return Promise.resolve(item);
    }
    
    if(item._id) {
        return apiFetch<DocumentationDoc>(`${apiPath}/${item._id}`, "put", changes);
    } else {
        throw new Error("nothing to save");
    }
}


export const useDocumentationStartPage = (): DocumentationPageData => {
    const load = useCallback(() => {
        return apiFetch<DocumentationDoc>(`${ApiPath}/slug/start`, "get");
    }, []);

    const data = useCrudItemF({
        defaultValue: { _id: "", title: "", content: undefined },
        load,
        saveChanges: (item, changes) => saveDocument(ApiPath, item, changes),
        remove: async (item) => {},
    });


    const [viewMode, setViewMode] = useState<boolean>(true);

    return {
        ...data,
        
        viewMode,
        setViewMode,
        search: {
          clearFilter: () => {},
          filter: "",
          results: {
            data: [],
            isLoading: false,
            reload: () => {},
            setData: () => {},

          },
          isActive: false,
          setIsActive: () => {},
          isSearching: false,
          setFilter: () => {},
        },
    }
}

export const DocumentationStartPage = () => {
  // const { config } = useDocumentationPages();

  const data = useDocumentationStartPage();
  // useTrackHistory(data.data.title);

  return (
    <MediaLibProviderX>
      <DocumentationPageUnbound
        apiPath={ApiPath}
        pagePath=""
        rootSlug="start"
        data={data}
        editor={ProjectDocumentationEditor}
        />
    </MediaLibProviderX>
  );
}
